import React, { FC, useEffect, useState } from 'react'

import TopBars from '@/components/TopBars'
import moment from 'moment'
import {
	Dispatch,
	GlobalModelState,
	connect,
	dateSelectorType,
	pullDownMenuType,
} from 'umi'
import CommonSelector from '../CommonSelector'
import ProjectSelector from '../ProjectSelector'
import './index.less'

export interface HeanBarsProps {
	dispatch: Dispatch
	global: GlobalModelState
	handleSelectorChange: any
	handleArea: any
	handleCity: any
	projectSelectValue: any
	areaSelectValue: any
	citySelectValue: any
	renderTime: any
}

const HeadBars: FC<HeanBarsProps> = ({
	dispatch,
	global,
	handleSelectorChange,
	handleArea,
	handleCity,
	// selectValueProps,
	projectSelectValue,
	areaSelectValue,
	citySelectValue,
	renderTime,
}) => {
	const { fixedDate, dateValue } = global
	const [refreshState, setRefreshState] = useState(false)

	// useEffect(()=>{
	// 	return ()=>{
	// 		renderTime(dateSelectorType.today)
	// 	}
	// },[])

	useEffect(() => {
		dispatch({
			type: 'global/save',
			payload: {
				refresh: refreshState,
			},
		})
	}, [refreshState])

	/* 时间段选择处理 */
	const onRadioChange = (e: {
		target: { value: React.SetStateAction<string> }
	}) => {
		/* 修改选择 */
		// dispatch({
		// 	type: 'global/save',
		// 	payload: {
		// 		fixedDate: e.target.value,
		// 	},
		// })
		// setFixedDate(e.target.value)
		renderTime(e.target.value)
	}

	/* 日期选择器选择处理 */
	const onRangePickerChange = (dates, dateStrings) => {
		console.log('dates', dates)
		console.log('dateStrings', dateStrings)
		dispatch({
			type: 'global/save',
			payload: {
				fixedDate: '',
				dateValue: dateStrings,
			},
		})
	}

	/* 数据下载 */
	const downLoadFile = () => {
		let params: any = {}
		if (fixedDate) {
			params.fixedDate = fixedDate
		} else {
			let startTime = dateValue[0].format('YYYY-MM-DD 00: 00: 00')
			let endTime = dateValue[1].format('YYYY-MM-DD 23: 59: 59')
			params.startTime = startTime
			params.endTime = endTime
		}
		/* 请求下载 */
		// dispatch({
		// 	type: 'dashboard/downloadApplicationUser',
		// 	payload: params,
		// })
	}

	/* 数据刷新 */
	const refreshData = () => {
		setRefreshState(!refreshState)
	}

	return (
		<div className="HeadBars-container">
			{/* 项目选择器 */}
			<ProjectSelector
				selectValueProps={projectSelectValue}
				handleSelectorChange={handleSelectorChange}
				options={global.projectOption}
				placeholder={pullDownMenuType.projectOption}
			/>
			{/* 地区选择器 */}
			<ProjectSelector
				selectValueProps={areaSelectValue}
				handleSelectorChange={handleArea}
				options={global.areaOption}
				placeholder={pullDownMenuType.areaOption}
			/>
			{/* 城市选择器 */}
			<ProjectSelector
				selectValueProps={citySelectValue}
				handleSelectorChange={handleCity}
				options={global.cityOption}
				placeholder={pullDownMenuType.cityOption}
			/>

			{/* 地区选择器 */}
			{/* <CommonSelector
				handleSelectorChange={handleArea}
				options={global.areaOption}
				placeholder={pullDownMenuType.areaOption}
			/> */}
			{/* 城市选择器 */}
			{/* <CommonSelector
				handleSelectorChange={handleCity}
				options={global.cityOption}
				placeholder={pullDownMenuType.cityOption}
			/> */}
			{/* 其它工具栏 */}
			<TopBars
				fixedDate={fixedDate}
				dateType=""
				dateValue={dateValue}
				onRadioChange={onRadioChange}
				onRangePickerChange={onRangePickerChange}
				downLoadFile={downLoadFile}
				onRefresh={refreshData}
			/>
		</div>
	)
}

export default connect(({ global }: { global: GlobalModelState }) => ({
	global,
}))(HeadBars)
